module.exports = __webpack_public_path__ + "img/powered_by_horizontal_p.eaf0bbc3.png";